export const getDefaultOptionLocation = (location) => {
  return {
    name: `${location?.attributes?.location} ${location?.attributes?.marina ? `- ${location.attributes.marina}` : ''} ${location?.attributes?.area ? `- ${location.attributes.area}` : ''}`,
    id: location.id,
  };
};
